module.exports = __webpack_public_path__ + "img/banner-3.18147df1.png";